import { createContext, useCallback, useContext, useRef, useState } from "react";
import { CheckCircle2, X, XCircle } from "lucide-react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const remove = useCallback((id) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  }, []);

  const push = useCallback((type, message) => {
    const id = ++idRef.current;
    setToasts((current) => [...current, { id, type, message }]);
    setTimeout(() => remove(id), 4500);
  }, [remove]);

  const toast = {
    success: (message) => push("success", message),
    error: (message) => push("error", message),
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="ops-toast-stack" aria-live="polite">
        {toasts.map((item) => (
          <div key={item.id} className={`ops-toast ops-toast--${item.type}`}>
            {item.type === "success" ? <CheckCircle2 size={16} /> : <XCircle size={16} />}
            <span>{item.message}</span>
            <button type="button" className="ops-toast-close" onClick={() => remove(item.id)} aria-label="Dismiss">
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) throw new Error("useToast must be used inside ToastProvider");
  return context;
}
